/**
 * http/https のスキームとホストを持つ URL かどうか（BM-008）。
 * javascript: や data: などはリンクとして描画されると XSS になるため拒否する。
 * バックエンド（backend/src/utils/url.ts, backend-go/pkg/validate）と同じ方針。
 */
export const MAX_URL_LENGTH = 2048;

export function isSafeHttpUrl(value: unknown): value is string {
  if (typeof value !== 'string' || value === '' || value.length > MAX_URL_LENGTH) return false;
  if (/[\s"'<>`]/.test(value)) return false;
  try {
    const url = new URL(value);
    return (url.protocol === 'http:' || url.protocol === 'https:') && url.hostname !== '';
  } catch {
    return false;
  }
}
